/** Internal only for now, and the address is the only thing that says so. */
export const INTERNAL_EMAIL_DOMAIN = '@brandlive.com';

export enum AccessState {
	Pending = 'pending',
	NotSignedIn = 'not-signed-in',
	NotInternal = 'not-internal',
	NotChannelProducer = 'not-channel-producer',
	Granted = 'granted',
}

export const isInternalEmail = (email?: string | null): boolean => (
	!!email && email.trim().toLowerCase().endsWith(INTERNAL_EMAIL_DOMAIN)
);

export interface AccessInputs {
	token?: string | null;
	email?: string | null;
	isProducer: boolean;
	channelIds: number[] | null; /** Null until the profile lands. */
	channel?: number | null; /** `undefined` while the room resolves, `null` if it resolved without one. */
}

/**
 * A UI gate, not a boundary: every input comes from state this browser already
 * holds. What actually protects the data is that every panel behind it is
 * fetched from a service that authorises the token itself.
 */
export function accessState({
	token,
	email,
	isProducer,
	channelIds,
	channel,
}: AccessInputs): AccessState {
	if (!token) return AccessState.NotSignedIn;
	if (!isInternalEmail(email)) return AccessState.NotInternal;
	if (channelIds === null || channel === undefined) return AccessState.Pending;
	if (!isProducer || channel === null) return AccessState.NotChannelProducer;

	return channelIds.includes(channel)
		? AccessState.Granted
		: AccessState.NotChannelProducer;
}
